/*
File: UnPayBill 补缴清单
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import React, { useMemo, useState, useEffect, useCallback } from 'react'
import { Button, Modal, Table, message } from 'antd'
import BillWithDate from './BillWithDate'
import * as dateFns from 'date-fns/fp'
import * as R from 'ramda'
import { useAction } from '@/hooks/useAction'
import PayConfirmModal from './payConfirm'
import PaginationTable from '@cmps/PaginationTable/PaginationTable'

import {
  anchorServiceBackBill,
  extGoodsBackPayDetail,
} from '@/api/api'

const detailColumns = [
  {
    title: '商品名称',
    dataIndex: 'goodsName',
  },
  {
    title: '累积获得收益(金豆)',
    dataIndex: 'latestTotalData',
  },
  {
    title: '欠费金额(虎牙币)',
    dataIndex: 'latestExpense',
    render: (value, row) => <span>{ parseInt(R.min(value, R.defaultTo(Infinity, row.maxFee)), 10) / 100 }</span>,
  },
]

const initStartTime = R.compose(dateFns.startOfMonth, dateFns.subMonths(6))(new Date())
const initEndTime = dateFns.endOfMonth(new Date())

function UnPayBill() {
  const [isDetailVisible, toggleDetail] = useState(false)

  // const [detailState, performGetDetail] = useAction(extGoodsBackPayDetail)

  const [payRecord, setPayRecord] = useState({})

  const [detailParam, setDetailParam] = useState({
    month: null,
    extUuid: null,
  })

  const [isPayModalVisible, togglePayModal] = useState(false)

  const [reFetchCnt, setReFetchCnt] = useState(0)

  const handleClickPay = useCallback(record => {
    // 两种进入路径 1. 直接点补缴 2. 在详情页点补缴(这种情况没有参数进来)
    if (record) {
      setPayRecord({
        extName: R.path(['extInfo', 'name'], record),
        extUuid: R.path(['extInfo', 'extUuid'], record),
        time: R.prop('time', record),
        fee: R.prop('fee', record),
        orderId: R.prop('orderId', record),
      })
    }


    togglePayModal(true)
  }, [])

  const handleClickDetail = useCallback(record => {
    console.log(record)

    setPayRecord({
      extName: R.path(['extInfo', 'name'], record),
      extUuid: R.path(['extInfo', 'extUuid'], record),
      time: R.prop('time', record),
      fee: R.prop('fee', record),
      orderId: R.prop('orderId', record),
    })

    setDetailParam({
      month: R.prop('time', record),
      extUuid: R.path(['extInfo', 'extUuid'], record),
    })

    /*
     * performGetDetail({
     *   page: 1,
     *   pageSize: 500,
     * })
     */

    toggleDetail(true)
  }, [])

  const handlePaySuccess = useCallback(() => {
    message.success('补缴成功')

    togglePayModal(false)

    // 刷新页面
    setReFetchCnt(R.inc)
  }, [])

  /*
   * const detailDataSource = useMemo(() => {
   *   return R.compose(
   *     R.defaultTo([]),
   *     R.path(['respData', 'serviceBacks']),
   *   )(detailState)
   * }, [detailState.respData])
   */

  const columns = useMemo(() => [
    {
      title: '未缴费小程序',
      dataIndex: 'extInfo.name',
    },
    {
      title: '未缴费月份',
      dataIndex: 'time',
    },
    {
      title: '欠费金额(元)',
      dataIndex: 'fee',
      render: fee => <span>{ R.divide(R.defaultTo(0, fee), 100)}</span>,
    },
    {
      title: '操作',
      index: 'action',
      render: (text, record) => (
        <div>
          <Button size="small" onClick={() => handleClickDetail(record)}>查看明细</Button>
          <Button size="small" onClick={() => handleClickPay(record)} style={{ marginLeft: '10px' }}>补缴</Button>
        </div>
      ),
    },
  ], [])

  return (
    <div>
      {
        true
          ? null
          : (
            <BillWithDate
              fetcher={anchorServiceBackBill}
              columns={columns}
              transformer={R.prop('serviceBacks')}
              initStartTime={initStartTime}
              initEndTime={initEndTime}
              reFetchCnt={reFetchCnt}
            />
          )
      }

      <PaginationTable
        fetcher={anchorServiceBackBill}
        transformer={R.path(['serviceBacks'])}
        columns={columns}
        reFetchCnt={reFetchCnt}
      />

      <Modal
        title="欠费明细"
        visible={isDetailVisible}
        onOk={() => toggleDetail(false)}
        onCancel={() => toggleDetail(false)}
        footer={null}
        bodyStyle={{ padding: 0 }}
        key={`${JSON.stringify(detailParam)}`}
        width={540}
      >
        <div>
          <PaginationTable
            fetcher={pageParam => extGoodsBackPayDetail({ ...pageParam, ...detailParam })}
            columns={detailColumns}
          />
          <div style={{ padding: '10px 20px', display: 'flex'  }}>
            <p style={{ flexGrow: '1', margin: '0' }}>欠费金额: {parseInt(payRecord.fee, 10) / 100} 虎牙币</p>
            <Button size="small" type="primary" onClick={() => handleClickPay()}>立即补缴</Button>
          </div>
        </div>
      </Modal>

      {
        !isPayModalVisible
          ? null
          : <PayConfirmModal
            info={payRecord}
            closeConfirm ={() => togglePayModal(false)}
            paySuccess={handlePaySuccess}
          />
      }
    </div>
  )
}

export default UnPayBill
